// extracted by mini-css-extract-plugin
export default {"root":"FieldCheckboxGroup_root__6U6uX","list":"FieldCheckboxGroup_list__AI7Hq","twoColumns":"FieldCheckboxGroup_twoColumns__alQeC","item":"FieldCheckboxGroup_item__nM4qB"};